import { useState } from "react";
import { Smile } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { QUICK_REACTIONS } from "@/hooks/useMessageReactions";
import { cn } from "@/lib/utils";

interface ReactionPickerProps {
  onSelectEmoji: (emoji: string) => void;
  existingReactions?: string[];
  className?: string;
}

export const ReactionPicker = ({ onSelectEmoji, existingReactions = [], className }: ReactionPickerProps) => {
  const [open, setOpen] = useState(false);

  const handleSelect = (emoji: string) => {
    onSelectEmoji(emoji);
    setOpen(false);
  };

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button
          variant="ghost"
          size="icon"
          className={cn("h-7 w-7 text-muted-foreground hover:text-foreground", className)}
        >
          <Smile className="h-4 w-4" />
        </Button>
      </PopoverTrigger>
      <PopoverContent 
        side="top" 
        align="start" 
        className="w-auto p-2"
        sideOffset={5}
      >
        <div className="flex flex-wrap gap-1 max-w-[200px]">
          {QUICK_REACTIONS.map((emoji) => (
            <button
              key={emoji}
              onClick={() => handleSelect(emoji)}
              className={cn(
                "p-1.5 rounded hover:bg-accent text-lg transition-colors",
                existingReactions.includes(emoji) && "bg-primary/10"
              )}
            >
              {emoji}
            </button>
          ))}
        </div>
      </PopoverContent>
    </Popover>
  );
};
